import React from "react";

interface AdminErrorAlertProps {
  error: string | null;
}

const AdminErrorAlert: React.FC<AdminErrorAlertProps> = ({ error }) => {
  if (!error) return null;
  return (
    <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">{error}</div>
  );
};

export default AdminErrorAlert;
